import { render } from "./CourseImage.vue?vue&type=template&id=610a68f2&scoped=true"
import script from "./CourseImage.vue?vue&type=script&lang=js"
export * from "./CourseImage.vue?vue&type=script&lang=js"

import "./CourseImage.vue?vue&type=style&index=0&id=610a68f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610a68f2"]])

export default __exports__